module.exports = __webpack_public_path__ + "static/media/Water-Leak.eeffec6f.jpg";